import React, { useState, useEffect, useRef } from 'react';
import { Upload, QRCode, message, Button } from 'antd';
import { PlusOutlined, CloseOutlined, QrcodeOutlined } from '@ant-design/icons';
import useWebPost from '../utils/useWebPost';
import renderFileList from './renderFileList';
import { webqiniu } from '../utils/Variable';
import {getuptoken} from '../utils/functions'
const { Dragger } = Upload;

const ImgUploader = ({ value , onChange }) => {
    const webPost = useWebPost();
    const [fileList, setFileList] = useState([]);
    const [fileList2, setFileList2] = useState([]);
    const [upcount, setUpcount] = useState(0);
    const [fkey, setFkey] = useState(0);
    const admin = localStorage.getItem('admin') ? JSON.parse(localStorage.getItem('admin')) : [];
    

    // useEffect(() => {
    //     setFileList2(fileList);
    // }, [fileList]);

    useEffect(() => {
        if(fkey!==0){
            onChange(fileList.join(','));
        }
    }, [fkey]);

    useEffect(() => {
        if(Array.isArray(value)){
            setFileList(value);
        }else{
            if(value){
                setFileList(value.split(','));
            }else{
                setFileList([]);
            }
        }
    }, [value]);


    const newUpload = (d) => {
        if (d && d.key) {
            setFileList(prevFileList => [...prevFileList, d.key]);
            setFkey(Math.random());
        }
    }
    const uploadProps = {
        accept: '.pdf,.jpg,.jpeg,.png,.mp4,.doc,.docx,.xls,.xlsx,.zip,.rar,.7z',
        multiple: true,
        fileList: [],
        showUploadList: false,
        customRequest: async ({ file, onSuccess, onError }) => {
            const uptoken = await getuptoken(webPost);
            if (!uptoken) {
                onError(new Error('无法获取上传凭证'));
                message.error('无法获取上传凭证，无法上传');
                return;
            }
            
            const formData = new FormData();
            formData.append('token', uptoken);

            const directory = 'ofs/a' + admin?.id;
            const fileExtension = file.name.split('.').pop();
            const timestamp = file.name + '_'+new Date().getTime() + '_' + admin?.id + '_' + upcount;
            setUpcount(prev => prev + 1);
            const newFileName = `${timestamp}.${fileExtension}`;
            const key = `${directory}/${newFileName}`;
            formData.append('key', key);
            formData.append('file', file);

            try {
                const response = await fetch(
                    webqiniu,
                    {
                        method: 'POST',
                        body: formData
                    }
                );
                if (!response.ok) {
                    throw new Error(`上传失败，HTTP状态码：${response.status} ${response.statusText}`);
                }
                const responseData = await response.text();
                if (responseData) {
                    newUpload(JSON.parse(responseData));
                }
            } catch (error) {
                console.error('文件上传失败', error);
                onError(error);
            }
        },
        // onChange: handleUploadChange
    };

    const handleDelete = (index) => {
        const newLfpath = [...fileList];
        newLfpath.splice(index, 1);
        setFileList(newLfpath);
        setFkey(Math.random());
    };

    return (
        <div className='flex2'>
            <div className="upload-thumbnails">
                {fileList.map((file, index) => {
                    if (file) {
                        return (
                            <div key={file} style={{ position: 'relative', display: 'inline-block' }}>
                                <div
                                    style={{ width: '100px', height: '100px', objectFit: 'cover', margin: '5px' }}>
                                    {renderFileList(file, 100)}</div>
                                <CloseOutlined
                                    style={{
                                        position: 'absolute',
                                        top: '5px',
                                        right: '5px',
                                        cursor: 'pointer',
                                        color: 'white',
                                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                        padding: '2px',
                                        borderRadius: '50%',
                                        zIndex:100,
                                    }}
                                    onClick={() => handleDelete(index)}
                                />
                            </div>
                        )
                    } else {

                    }
                })}
            </div>

            <div style={{ width: '140px', height: '140px', position: 'relative' }}>
                <Dragger {...uploadProps}>
                    <div style={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column'
                    }}>
                        <PlusOutlined style={{ fontSize: '24px' }} />
                        <div>点击或拖拽上传</div>
                    </div>
                </Dragger>
            </div>
        </div>
    );
};

export default ImgUploader;